import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/real-property.png'
import _imports_1 from '@/assets/images/shape-9.png'


const _hoisted_1 = {
  class: "border-0 rounded-3 position-relative mb-4 overflow-hidden",
  style: {"background":"linear-gradient(101deg, #fe7a36 0%, #fd5812 100%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"row\"><div class=\"col-sm-7\"><div class=\"p-4 pe-0\"><span class=\"text-white d-block mb-2\">Active Total Property</span><h3 class=\"fs-20 text-white\">507,020</h3></div></div><div class=\"col-sm-5 mt-md-3 mt-xxl-0\"><div class=\"pt-sm-4 mt-sm-3 text-end\"><img src=\"" + _imports_0 + "\" style=\"width:188px;height:125px;\" alt=\"real-property\"><img src=\"" + _imports_1 + "\" class=\"position-absolute bottom-0 start-0\" alt=\"shape\"></div></div></div>", 1)
  ]))]))
}